module.exports = __webpack_public_path__ + "static/media/insurance.abd9fcb4.svg";